//import api from '../../api'

// initial state
import api from "../../api";

const state = {
    link: {},
    payment: {},
};

// getters
const getters = {};

// actions
const actions = {
    _idealPayment({}, data){
        return new Promise((resolve, reject)=>{
            api
            .post('firstpayment/ideal', data)
            .then(response => {
                resolve(response.data.data);
            }).catch(error =>{
                reject(error);
            });
        });
    },
    _bancontactPayment({}, data){
        return new Promise((resolve, reject) => {
            api
            .post('firstpayment/bancontact', data)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
            });
        });
    },
    _creditcardPayment({}, data){
        return new Promise((resolve, reject) => {
            api
                .post('firstpayment/creditcard', data)
                .then(response => {
                    console.log(response.data);
                    if(response.data.success){
                         resolve(response.data.link)
                    }
                }).catch(error => {
                reject(error);
            });
        });
    },
    _getPaymentById({}, data){
        return new Promise((resolve, reject) => {
            api.get('realpayment/' + data)
                .then(response => {
                    if(response.data.success){
                        resolve(response.data.data);
                    }
                })
                .catch(error =>{
                    reject(error);
                });
        });
    },
    _getLink({commit}, data){
        return new Promise((resolve, reject) => {
            api.post('link/check', data)
                .then(response => {
                    if(response.data.success){
                        commit('_link', response.data.link);
                        commit('_payment', response.data.payment);

                        resolve('good');
                    }else{
                        resolve(response.data.message);
                    }
                })
                .catch(error =>{
                    reject(error);
                });
        });
    },
    _bancontactPaymentLink({}, data){
        return new Promise((resolve, reject) => {
            api.post('link/bancontact', data)
                .then(response => {
                    if(response.data.success){
                        resolve(response.data.url.url);
                    }
                })
                .catch(error =>{
                    reject(error);
                });
        });
    },
    _idealSubscriptionPayment({}, data){
        return new Promise((resolve, reject) => {
            api.post('link/subscription/ideal', data)
            .then(response => {
                if (response.data.success) {
                    resolve(response.data.url.url);
                }
            })
            .catch(error => {
                reject(error);
            });
        });
    },
    _creditcardPaymentSubscription({}, data){
            return new Promise((resolve, reject) => {
                api
                    .post('link/subscription/creditcard', data)
                    .then(response => {
                        if(response.data.success){
                            resolve(response.data.link)
                        }
                    }).catch(error => {
                    reject(error);
                });
            });
        }
};

const mutations = {
    _link(state, link){
        state.link = link;
    },
    _payment(state, payment){
        state.payment = payment;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
